import { A } from '@mobily/ts-belt';
import { Stack, Text } from '@stitch-fix/mode-react';
import { useWardrobeCopy } from '../../../utils/contexts/copy-provider';
import { useGetTopItemsQuery } from '../../../utils/hooks/getTopItems';
import { useBoughtItemsMachine } from '../../../utils/machines/boughtItems/context-provider';
import { TopItemsCarousel } from './TopItemsCarousel';
import TopItemsEmptyState from './TopItemsEmptyState';

/**
 * <TopItems /> handles the display of the Top items title as well
 * as the rendering of the placeholder vs the carousel
 */
export const TopItems = () => {
  const {
    state
  } = useBoughtItemsMachine();
  const {
    copy
  } = useWardrobeCopy();
  const {
    data: topItemsData,
    loading
  } = useGetTopItemsQuery({
    fetchPolicy: 'cache-and-network',
    skip: !state.matches('success')
  });
  const {
    topItems = [],
    endCard
  } = topItemsData?.client?.wardrobe.boughtModule.topItemsModule ?? {};
  const shouldShowEmptyState = !loading && A.isEmpty(topItems);
  return <Stack spacing={1} mb={1}>
      <Text setting="title-medium" align="left">
        {copy.topItemsModuleHeading}
      </Text>

      {shouldShowEmptyState ? <TopItemsEmptyState /> : <TopItemsCarousel loading={loading} topItems={topItems} endCard={endCard} />}
    </Stack>;
};